import Handlebars from "handlebars";
const templateString=`<div class="paperflite_content__attachments" width="274" style="width:274px; background: rgba(219, 219, 219, 0.25); border-radius: 1rem;">
  <table width="264px" style=" max-width: 274px;">
    <!--[if mso]>
    <table width="264" style="width: 264px;">
  <![endif]-->
    <tr style ="border: none !important">
      <td>
        <a href="{{defaultValue @root.contact.url 'contact.url'}}/collections/{{share.id}}" target="_blank"
          style="overflow:hidden; white-space:nowrap; text-decoration: none; cursor: pointer; padding: 1px 0; border: none;"
          data-widget-assetType="section" data-widget-placeholder="\{{contact.url}}/collections/\{{share.id}}">
          <img src="{{collectionIcon}}" width="275" height="90"
            style="max-width: 16.125rem; height: 7.75rem; padding: 0.38rem; border-radius: 1rem;  object-fit:cover; display: block">
        </a>
      </td>
    </tr>
    <tr>
      <td>
        <div style="padding:8px;">
          <div dir="ltr" style="width:274px; overflow: hidden; 
          text-overflow: ellipsis; white-space: nowrap;font-family: 'arial'; 
          color: #000000; font-weight: 600; 
          font-size:14px; margin-bottom: 0px; 
          text-decoration: none; vertical-align: bottom; 
          text-overflow: ellipsis;">
            {{truncate collection.name 30}}
          </div>
          <div dir="ltr" style="font-family: 'arial'; 
        color: #717273; font-weight: 400; 
        font-size: 10px; margin: 0px; 
        line-height:14px;">
            {{sections.length}} Sections
          </div>
        </div>
      </td>
    </tr>
    <!--[if mso]>
    </table>
  <![endif]-->
  </table>
</div>`

const template = Handlebars.compile(templateString);
export default template;
